import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import {
  CommentListItem,
  CustomLink,
  CustomStack,
  CustomTextField,
  SectionWrapper,
} from '@components/Styles/CommonStyle';
import React, { useEffect, useState } from 'react';

import { CustomButton } from '@components/Styles/ButtonStyle';
import api from '@api/axios';
import moment from 'moment';
import { theme } from '@components/Styles/theme';
import { useLoading } from '@context/LoadingContext';
import { useDialog } from '@context/DialogContext';

const ProjectCreateTableCommentV2 = ({ id }) => {
  const { showDialog } = useDialog();
  const { showLoading, hideLoading } = useLoading();

  const [commentList, setCommentList] = useState([]);
  const [commentListEditFlag, setCommentListEditFlag] = useState([]);
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 댓글 등록
  const createComment = () => {
    const url = '/api/project/createPlannedProjectComment?id=' + id;

    // 댓글 등록 중복 방지
    if (isSubmitting) return;
    setIsSubmitting(true);

    showLoading();
    api
      .post(url, { comment: comment })
      .then((res) => {
        console.log('댓글 작성하기 :: res');
        console.log(res);
        if (res.status === 201) {
          // 댓글 새로 불러오기
          readComment();
          setComment('');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        hideLoading();
        setIsSubmitting(false);
      });
  };

  // 댓글 삭제하기 (알림 호출)
  const deleteCommentAlert = (commentId) => {
    showDialog({
      type: 'confirm',
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      onConfirm: () => {
        deleteComment(commentId);
      },
    });
  };

  // 댓글 삭제하기 (API 호출)
  const deleteComment = (commentId) => {
    const url = '/api/project/deletePlannedProjectComment?commentId=' + commentId;

    showLoading();
    api
      .delete(url)
      .then((res) => {
        console.log('댓글 삭제하기 :: res');
        console.log(res);
        if (res.status === 201) {
          readComment();
          setComment('');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        hideLoading();
      });
  };

  // 댓글 수정하기 (API 호출)
  const updateComment = (commentId, comment) => {
    const url = '/api/project/updatePlannedProjectComment';

    showLoading();
    api
      .put(url, { comment: comment, commentId: commentId })
      .then((res) => {
        console.log('댓글 수정하기 :: res');
        console.log(res);
        if (res.status === 201) {
          readComment();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        hideLoading();
      });
  };

  // 댓글 불러오기 (API 호출)
  const readComment = () => {
    const url = '/api/project/readPlannedProjectComment?id=' + id;

    showLoading();
    api
      .get(url)
      .then((res) => {
        console.log('댓글 불러오기 :: res');
        console.log(res);
        if (res.status === 200) {
          setCommentList(res.data.result);
          setCommentListEditFlag(res.data.result.map((item) => false));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    readComment();
  }, []);

  return (
    <React.Fragment>
      <SectionWrapper data-section="comment">
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>진행현황</Typography>
        </CustomStack>

        <Box>
          {/* 댓글 등록 */}
          <Box>
            <CustomTextField
              multiline
              multi="12px 16px"
              rows={4}
              maxWidth="unset"
              placeholder="진행현황에 대하여 입력해주세요."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <CustomStack justifyContent="end" mt={2}>
              <CustomButton onClick={createComment}>등록</CustomButton>
            </CustomStack>
          </Box>

          {/* 댓글 목록 */}
          <Box>
            <List>
              {commentList && commentList.length > 0 ? (
                commentList.map((item, index) =>
                  !commentListEditFlag[index] ? (
                    // 댓글 조회
                    <CommentListItem>
                      <Box sx={{ width: '100%' }}>
                        <CustomStack justifyContent="spaceBetween">
                          <CustomStack mb={2}>
                            <Typography sx={theme.typography.h6}>{item.created_user_name}</Typography>
                            <Typography sx={{ ...theme.typography.body1, color: theme.palette.gray.main }}>
                              {moment(item.created_at).format('YYYY-MM-DD')}
                            </Typography>
                          </CustomStack>
                          <CustomStack mb={2}>
                            <CustomLink
                              pr={16}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              <Typography
                                sx={theme.typography.button}
                                onClick={() => {
                                  setCommentListEditFlag(
                                    commentListEditFlag.map((item, itemIndex) => {
                                      if (index === itemIndex) {
                                        return !item;
                                      }
                                      return item;
                                    }),
                                  );
                                }}
                              >
                                수정
                              </Typography>
                            </CustomLink>
                            <CustomLink
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              <Typography sx={theme.typography.button} onClick={() => deleteCommentAlert(item.id)}>
                                삭제
                              </Typography>
                            </CustomLink>
                          </CustomStack>
                        </CustomStack>
                        <Typography sx={{ ...theme.typography.body1, whiteSpace: 'pre-line' }}>
                          {item.comment}
                        </Typography>
                      </Box>
                    </CommentListItem>
                  ) : (
                    // 댓글 수정
                    <CommentListItem>
                      <Box sx={{ width: '100%' }}>
                        <CustomStack justifyContent="spaceBetween">
                          <CustomStack mb={2}>
                            <Typography sx={theme.typography.h6}>{item.created_user_name}</Typography>
                            <Typography sx={{ ...theme.typography.body1, color: theme.palette.gray.main }}>
                              {moment(item.created_at).format('YYYY-MM-DD')}
                            </Typography>
                          </CustomStack>
                          <CustomStack mb={2}>
                            <CustomLink
                              pr={16}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              <Typography
                                sx={theme.typography.button}
                                onClick={() => {
                                  showDialog({
                                    type: 'confirm',
                                    title: '확인',
                                    message: '정말 수정하시겠습니까?',
                                    onConfirm: () => {
                                      updateComment(item.id, commentList[index].comment);
                                      setCommentListEditFlag(
                                        commentListEditFlag.map((item, itemIndex) => {
                                          if (index === itemIndex) {
                                            return !item;
                                          }
                                          return item;
                                        }),
                                      );
                                    },
                                  });
                                }}
                              >
                                수정
                              </Typography>
                            </CustomLink>
                            <CustomLink
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              <Typography sx={theme.typography.button} onClick={() => deleteCommentAlert(item.id)}>
                                삭제
                              </Typography>
                            </CustomLink>
                          </CustomStack>
                        </CustomStack>
                        <CustomTextField
                          multiline
                          multi="12px 16px"
                          rows={4}
                          maxWidth="unset"
                          placeholder="진행현황에 대하여 입력해주세요."
                          value={commentList[index].comment}
                          onChange={(e) => {
                            setCommentList(
                              commentList.map((item, itemIndex) => {
                                if (index === itemIndex) {
                                  return { ...item, comment: e.target.value };
                                }
                                return item;
                              }),
                            );
                          }}
                        />
                      </Box>
                    </CommentListItem>
                  ),
                )
              ) : (
                // 댓글 없음
                <ListItem>
                  <ListItemText
                    sx={{ my: 6 }}
                    secondary={
                      <Typography
                        sx={{
                          ...theme.typography.body1,
                          whiteSpace: 'pre-line',
                          color: '#727272',
                          textAlign: 'center',
                        }}
                      >
                        등록된 댓글이 없습니다.
                      </Typography>
                    }
                  />
                </ListItem>
              )}
            </List>
          </Box>
        </Box>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default ProjectCreateTableCommentV2;
